class BackInStockButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("mouseenter", () => {
      this._getData();
    });

    this.addEventListener("click", (e) => {
      const button = e.target.closest("[data-bis-button]");

      if (!button) return;

      button.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: {
            html: this._getData(),
            target: "bis-modal",
            closeOthers: true,
          },
        }),
      );
    });
  }

  _getData() {
    const url = new URL(`${window.location.origin}${this.url}`);
    url.searchParams.set("section_id", this.sectionId);

    this.lastUrl = url.toString();

    if (url === this.lastUrl) {
      if (this._data) return Promise.resolve(this._parseData(this._data));
      if (this.loadingData) return this.loadingData;
    }

    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((data) => {
        this._data = data;

        return this._parseData(data);
      });

    return this.loadingData;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    const targetEl = document
      .createRange()
      .createContextualFragment(section.querySelector("body").innerHTML);

    return targetEl;
  }

  get url() {
    return this.getAttribute("url");
  }

  get sectionId() {
    return this.getAttribute("section-id") || "back-in-stock-form";
  }
}

if (!customElements.get("back-in-stock-button")) {
  customElements.define("back-in-stock-button", BackInStockButton);
}
